import { Divider, Form } from 'antd';
import { PageProps } from '@/types/PageProps';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import ByFinancialForm from '@/components/Reports/Commission/ByFinancialForm';
import { useQuestReportCommissionByFinancial } from '@/core/domain/questReport/Reports/CommissionByFinancial/CommissionByFinancial.hooks';
import useFileLoading, { FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import {
  QuestCommissionByFinancialFormValues,
  QuestCommissionByFinancialRequest,
  QuestSituation,
} from '@/core/domain/questReport/Reports/CommissionByFinancial/CommissionByFinancial.types';
import { DateTimeFormat } from '@/utils/moment';
import { useCommisionByFinancialCsv } from '@/core/domain/questReport/CSV/Commission/CommissionByFinancial/CommissionByFinancial.hooks';
import { useReportHandlers } from '@/hooks/useReportHandler';

const CommissionByFinancialPage = ({ route }: PageProps) => {
  const [form] = Form.useForm<QuestCommissionByFinancialFormValues>();

  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useQuestReportCommissionByFinancial();
  const generateReportCsv = useCommisionByFinancialCsv();

  const handleGenerateReport = async (
    format: FileType,
    callback?: ReportCallback,
  ) => {
    setFileLoading(format);

    try {
      const values = await form.validateFields();

      const obj: QuestCommissionByFinancialRequest = {
        filterBy: values.filterBy,
        deduction: values.deduction,
        companiesIds: values.companiesIds?.toString(),
        documentTypeIds: values.documentTypeIds?.toString(),
        employeesIds: values.employeesIds?.toString(),
        open: values.situation.includes(QuestSituation.open),
        settled: values.situation.includes(QuestSituation.settled),
        startDate: values.initialDate.format(DateTimeFormat),
        endDate: values.finalDate.format(DateTimeFormat),
      };

      const result =
        format === 'PDF' || format === 'REPORT_VIEW'
          ? await generateReport.mutateAsync(obj)
          : await generateReportCsv.mutateAsync(obj);

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };
  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_comissao_por_financeiro',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <ByFinancialForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
};

export default CommissionByFinancialPage;
